export default "__VITE_ASSET__dQ5ubEb5__"